// extracted by mini-css-extract-plugin
export default {"root":"oYG5LoRGQ1tTqi4srrk7","space":"BFUdK5CCQoLxGuxOMugN","balance":"ZPqiZyVSpMd08wrUFuLh","dots":"USSfiJWpXbT6tFDoCuTX","placeHolderShimmer":"zF248xOLicsPtD1o6Jqg"};